<div id="pnLogs" class="pnLogs sidebar xmlPannel pt-3" style="display: block" [class.closePannel]="check">
  <div class="pnclose">
    <div *ngIf="hideXMLClicks" (click)="closePannel()"><i class="fa fa-chevron-circle-left fa1x"></i></div>
  </div>
  <div class="d-flex p-2">
    <h3>XML Logs</h3>
    <span class="logsActionBtn">
      <i class="fa fa-sync sml" (click)="getLogs()"></i>
      <ng-template [ngIf]="hideXMLClicks">
        <i (click)="deleteLocal()" class="fa fa-trash" aria-hidden="true"></i>
        <i (click)="downloadAllXMLs()" class="fa fa-arrow-down sml"></i>
      </ng-template>
    </span>
  </div>
  <input type="hidden" id="log" name="log" value="0" />

  <div style="margin-top: 10px; margin-bottom: 20px">
    <ng-template [ngIf]="displayXmlLogList.length > 0">
      <ul class="logList" *ngFor="let log of displayXmlLogList; let i = index">
        <ng-template [ngIf]="log.key">
          <li>
            <a (click)="removeLog(log.key)"><i class="fa fa-times-circle"></i></a>
            <div class="xmlListTitle" (click)="viewLog(log.key)">
              {{ log.key.replace('.', '') }}
            </div>
            <a (click)="downloadXML(log.key)" class="fa fa-arrow-down sml"></a>
          </li>
        </ng-template>

        <!-- <ng-template [ngIf]="p.lbl != 0">
        <li>
          <ng-template [ngIf]="p.lbl !== ''">
            <a (click)="remove_log(p.id)"><i class="fa fa-times-circle"></i></a>
          </ng-template>
          <div class="xmlListTitle" (click)="view_log(p)">
            {{ p.lbl }}
          </div>
        </li>
      </ng-template> -->
      </ul>
    </ng-template>

    <!--<ng-template [ngIf]="pNumberList.length > 0 && displayResults.length > 0 && searchResults.length > pSettings.length">
      <nav aria-label="Page navigation example" class="mt-5">
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" (click)="triggerPagination('back')" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>

          <li *ngFor="let p of pNumberList" [class.active]="p.start === pSettings.start" class="page-item">
            <a class="page-link" (click)="updateStart(p.start)">{{ p.label }}</a>
          </li>

          <li class="page-item">
            <a class="page-link" (click)="triggerPagination('next')" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </ng-template>-->
    <ng-template [ngIf]="paginationButtonList.length > 0">
      <nav aria-label="Page navigation example" class="mt-5">
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" (click)="triggerPagination('back')" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>

          <li *ngFor="let p of paginationButtonList" [class.active]="p.start === pSettings.start" class="page-item">
            <a class="page-link" (click)="updateStart(p.start)">{{ p.label }}</a>
          </li>

          <li class="page-item">
            <a class="page-link" (click)="triggerPagination('next')" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </ng-template>
  </div>

  <div style="padding: 5px">
    <h4 *ngIf="hideXMLClicks">Performance Logs</h4>
  </div>
  <div style="margin-top: 10px; margin-bottom: 20px">
    <ng-template [ngIf]="performanceResults.length > 0">
      <ul class="logList performanceResults" *ngFor="let log of performanceResults; let i = index">
        <ng-template [ngIf]="log.key">
          <li>
            <div class="xmlListTitle spaceBetween">
              {{ log.key.replace('.', '') }}
            </div>
            <span class="ontooltip spaceBetween">{{ log.value.split('#')[0] }}<span class="tooltipContent">RQ/RS Time</span></span>
            <span class="ontooltip spaceBetween">{{ log.value.split('#')[1] }}<span class="tooltipContent">Processing RS Time</span></span>
            <span class="ontooltip spaceBetween">{{ log.value.split('#')[2] }}<span class="tooltipContent">Total Time</span></span>
          </li>
        </ng-template>
      </ul>
    </ng-template>
  </div>
</div>
